<template>
  <div id="page-wrap" v-if="loggedIn">
    <div class="container content-wrap">
      <div class="row">
        <form class="prepaid-form" @submit.prevent="proceedToPlan">
          <div class="row">
            <div class="col-md-12">
              <input
                class="account-id__input"
                type="tel"
                placeholder="Enter mobile number"
                v-model="recharge_account_id"
                v-focus
                v-numericOnly
                maxlength="10"
              />
              <p class="input-error-text">{{validationTextMobile}}</p>
            </div>
          </div>
          <div class="row mb-30">
            <div class="col-md-6 col-xs-6">
              <DropDown
                @on-change="selectOperator"
                title="Select Operator"
                valueName="operator"
                :items="operators"
              />
            </div>
            <div class="col-md-6 col-xs-6">
              <DropDown @on-change="selectRegion" title="Select Region" :items="regions" />
            </div>
          </div>
          <p class="text-red text-center">{{pageError}}</p>
          <ActionButton
            title="Continue"
            :disabled="!(recharge_account_id.length===10&&region&&operator)"
          />
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ActionButton from "@/components/ActionButton/index";
import DropDown from "@/components/DropDown/index";
export default {
  name: "Mobile",
  data() {
    return {
      query: {},
      pageError: "",
      validationTextMobile: "",
      validMobile: false,
      operatorsLoaded: false
    };
  },
  computed: {
    ...mapGetters([
      "operators",
      "regions",
      "loggedIn",
      "operator",
      "region",
      "valid_recharge_account_id"
    ]),
    recharge_account_id: {
      get() {
        return this.$store.state.recharge.recharge_account_id;
      },
      set(value) {
        return this.$store.commit("set_recharge_account_id", value);
      }
    }
  },
  components: { ActionButton, DropDown },
  mounted() {
    this.$store.dispatch("storeMixpanelEvent", {
      eventName: "BILL_PAYMENT_SELECTED",
      propertyName: "BILL_TYPE",
      propertyValue: "MOBILE"
    });
    this.$store
      .dispatch("getOperatorsAndRegions", this.$route.name)
      .then(resp => {
        this.operatorsLoaded = true;
      });
    this.$store.dispatch("setRechargeOperator", "");
    this.$store.dispatch("setRechargeRegion", "");
    this.$store.dispatch("setRechargeAccountId", "");
  },
  methods: {
    selectOperator(event) {
      const getOperator = event.target.value;
      this.$store.dispatch("setRechargeOperator", getOperator);
    },
    selectRegion(event) {
      const getRegion = event.target.value;
      this.$store.dispatch("setRechargeRegion", getRegion);
    },
    proceedToPlan() {
      this.pageError = "";
      if (this.valid_recharge_account_id && this.operator && this.region) {
        this.$store.dispatch("selectPlan", {
          amount: "",
          description: ""
        });
        this.$router.push({
          name: "ChoosePlan",
          params: { type: "Mobile" },
          query: this.$route.query
        });
      } else {
        this.pageError = "Please fill all the field.";
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.account-id {
  &__input {
    font-size: 20px;
    padding: 8px 16px;
    &::placeholder {
      font-size: 16px;
      color: #d6d4d4;
    }
    width: 100%;
    border-radius: 3px;
    border: solid 0.5px #d4d4d4;
    background-color: #ffffff;
    &:focus {
      outline: solid 1px #3482fd;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Mobile.vue